import {
  ImportStaffAssignRequestType,
  ImportStaffAssignResponseType,
  StaffAssignDetailResponseType,
  StaffAssignRequestType, StaffAssignResponseType
} from './types';

import axiosInstance from 'common/services/common/instance';

export const getAllStaffAssignService = async (
  params?: BaseFilterParams,
): Promise<APIPaginationResponse<Array<StaffAssignResponseType>>> => {
  const res = await axiosInstance.get('staff-assigns', { params });
  return res.data;
};

export const getStaffAssignService = async (
  id: number,
): Promise<StaffAssignDetailResponseType> => {
  const res = await axiosInstance.get(`staff-assigns/${id}`);
  return res.data.data;
};

export const deleteStaffAssignService = async (
  ids: number[],
): Promise<void> => {
  await axiosInstance.delete('staff-assigns', { data: { ids } });
};

export const createStaffAssignService = async (
  params: StaffAssignRequestType,
): Promise<void> => {
  await axiosInstance.post('staff-assigns', params);
};

export const updateStaffAssignService = async (
  params: { id: number, data: StaffAssignRequestType },
): Promise<void> => {
  await axiosInstance.put(`staff-assigns/${params.id}`, params.data);
};

export const getInfoStaffAssignByExistedIdCard = async (idCardNumber: string):
  Promise<StaffAssignDetailResponseType> => {
  const res = await axiosInstance.get(`staff-assigns/find-by-id-card/${idCardNumber}`);
  return res.data.data;
};

export const importStaffAssignTemplateService = async (): Promise<{ link: string }> => {
  const res = await axiosInstance.post('staff-assigns/import-template');
  return res.data.data;
};

export const importStaffAssignService = async (
  params: ImportStaffAssignRequestType,
): Promise<ImportStaffAssignResponseType> => {
  const bodyForm = new FormData();
  bodyForm.append('file', params.file);
  bodyForm.append('preview', params.preview ? '1' : '0');

  const res = await axiosInstance.post('staff-assigns/import', bodyForm);
  return res.data.data;
};

export const exportStaffAssignService = async (params?: any): Promise<{ link: string }> => {
  const res = await axiosInstance.post('exports/staff-assigns', null, { params });
  return res.data.data;
};
